import styled from 'styled-components';
import {
  textTransform,
} from '../Mixins';

const Option = styled.option`
	font-weight: ${({ theme }) => theme.option.fontWeight};

  ${textTransform}
`;

export default Option;
